import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import capitalize from 'lodash/capitalize';
import {
    WELCOME,
    ENGAGEMENT,
    PRE_ENGAGEMENT,
    CLOSED_ENGAGEMENT,
    PRELIMINARY_QUESTIONS,
    EXPIRED_ENGAGEMENT
} from 'constants/pageDictionary';
import AssessmentInfo from 'components/assessment-info/AssessmentInfo';
import Timer from 'containers/timer/Timer';
import attunedLogoSvg from 'images/attuned-logo.svg';
import './header.scss';

class Header extends Component {
    render() {
        const { respondentName, logoUrl, loadingLogo } = this.props;

        const pageName = this.props.pageName.get('goToPage');
        let fullName = '';
        if (respondentName.get('languageId') === 1 || respondentName.get('languageId') === 4) {
            fullName = respondentName && respondentName.get('firstName') ?
                `${ capitalize(respondentName.get('firstName')) } ${ capitalize(respondentName.get('lastName')) }` : '';
        } else {
            fullName = respondentName && respondentName.get('firstName') ?
                `${ capitalize(respondentName.get('lastName')) } ${ capitalize(respondentName.get('firstName')) }` : '';
        }
        if (pageName === ENGAGEMENT || pageName === EXPIRED_ENGAGEMENT) {
            return null;
        }
        return (
            <nav className='flowHeader'>
                <div className='row'>
                    <div className='col-xs-4 col-sm-6'>
                        <div className='fl-header-logo'>
                            {loadingLogo ? (
                                <React.Fragment />
                            ) : (
                                <img src={ logoUrl || attunedLogoSvg } alt='flow logo' />
                            )}
                        </div>
                    </div>
                    <div className='col-xs-8 col-sm-6'>
                        <div className='fl-v-center fl-nav-right'>
                            <AssessmentInfo
                                fullName={ fullName }
                                languageId={ respondentName.get('languageId') }
                                surveyId={ respondentName.get('surveyId') } />
                        </div>
                    </div>
                </div>
                { pageName && pageName !== WELCOME &&
                pageName !== PRE_ENGAGEMENT &&
                pageName !== CLOSED_ENGAGEMENT &&
                pageName !== PRELIMINARY_QUESTIONS &&
                respondentName.get('surveyId') === 4 &&
                <div className='header-timer'>
                    <Timer />
                </div> }
            </nav>
        );
    }
}


Header.propTypes = {
    pageName: PropTypes.object,
    respondentName: PropTypes.object,
    logoUrl: PropTypes.string,
    loadingLogo: PropTypes.bool
};

Header.defaultProps = {
    pageName: null,
    respondentName: null,
    logoUrl: null,
    loadingLogo: true
};

const mapStateToProps = (state) => ({
    respondentName: state.respondentNameReducer,
    pageName: state.pageReducer,
    logoUrl: state.logoReducer.get('logoUrl'),
    loadingLogo: state.logoReducer.get('loadingLogo')
});

export default connect(mapStateToProps, null)(Header);
